import { PageHero } from "../components/PageHero";
import { Reveal, Chapter } from "../components/Reveal";
import { CtaSection } from "./Home";
import { SiteImg } from "../hooks/useSiteImages";
import { T } from "../hooks/useSiteTexts";
import { IMAGES, PROJECT_AREAS } from "../data/content";

export default function Projetos() {
    return (
        <>
            <PageHero
                overline="Projetos"
                title="Experiência em operações de"
                accent="grande dimensão."
                subtitle={<T k="projetos-hero-sub" fallback="Colaboramos em projetos que exigem capacidade operacional, rigor e uma resposta logística eficiente." />}
                image={IMAGES.portNight}
                slot="projetos-hero"
            />

            <section className="mx-auto max-w-7xl px-6 py-28 lg:px-10" data-testid="projects-grid">
                <Reveal>
                    <Chapter num={1} label="Áreas de atuação" />
                    <h2 className="mt-8 max-w-3xl font-display text-4xl font-black uppercase leading-[1.02] tracking-tight sm:text-5xl">
                        Onde a nossa frota faz a{" "}
                        <span className="text-brand">diferença.</span>
                    </h2>
                </Reveal>
                <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {PROJECT_AREAS.map((p, i) => (
                        <Reveal
                            key={p.title}
                            delay={(i % 3) * 0.1}
                            className={i === 0 ? "sm:col-span-2" : ""}
                        >
                            <div
                                className="group relative h-full overflow-hidden border border-white/10"
                                data-testid={`project-area-${i}`}
                            >
                                <SiteImg
                                    slot={`project-${i + 1}`}
                                    fallback={p.image}
                                    alt={p.title}
                                    loading="lazy"
                                    className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${
                                        i === 0 ? "aspect-[2/1]" : "aspect-[4/3]"
                                    }`}
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/25 to-transparent" />
                                <div className="absolute inset-x-0 bottom-0 p-7">
                                    <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                    <h3 className="mt-2 font-display text-2xl font-black uppercase tracking-tight">
                                        {p.title}
                                    </h3>
                                    <p className="mt-2 max-w-md text-xs leading-relaxed text-zinc-400 md:text-sm">
                                        {p.desc}
                                        {p.descBold && (
                                            <span className="font-semibold text-zinc-200">
                                                {" "}{p.descBold}
                                            </span>
                                        )}
                                    </p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </section>

            <section className="border-y border-white/10 bg-coal" data-testid="projects-statement">
                <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10">
                    <Reveal>
                        <p className="max-w-4xl font-display text-3xl font-black uppercase leading-tight tracking-tight sm:text-4xl lg:text-5xl">
                            "Capacidade operacional, rigor e resposta logística{" "}
                            <span className="text-brand">eficiente.</span>"
                        </p>
                        <p className="mt-6 font-mono text-xs uppercase tracking-[0.3em] text-zinc-500">
                            O nosso compromisso em cada projeto
                        </p>
                    </Reveal>
                </div>
            </section>

            <CtaSection />
        </>
    );
}
